const captureVideoFrame = ({ videoElementId, mirror = false }) => {
  const video = document.getElementById(videoElementId);
  if (!video) return null;

  const displayWidth = video.clientWidth;
  const displayHeight = video.clientHeight;
  if (!displayWidth || !displayHeight) return null;

  const videoRatio = video.videoWidth / video.videoHeight;
  const displayRatio = displayWidth / displayHeight;

  let sx, sy, sw, sh;
  if (displayRatio > videoRatio) {
    sw = video.videoWidth;
    sh = video.videoWidth / displayRatio;
    sx = 0;
    sy = (video.videoHeight - sh) / 2;
  } else {
    sh = video.videoHeight;
    sw = video.videoHeight * displayRatio;
    sx = (video.videoWidth - sw) / 2;
    sy = 0;
  }

  const canvas = document.createElement('canvas');
  canvas.width = displayWidth;
  canvas.height = displayHeight;

  const ctx = canvas.getContext('2d');
  if (mirror) {
    ctx.translate(displayWidth, 0);
    ctx.scale(-1, 1);
  }
  ctx.drawImage(video, sx, sy, sw, sh, 0, 0, displayWidth, displayHeight);

  return canvas.toDataURL('image/jpeg', 0.8);
};

export default captureVideoFrame;
